import React from 'react';
import { MoneyBlocks } from './MoneyBlocks';
import type { WordpressPage } from '@benzinga/content-manager';
import styles from './MoneyPage.module.css';

export interface MoneyPageProps {
  page: Partial<WordpressPage>;
  showTitle?: boolean;
}

export const MoneyPage: React.FC<MoneyPageProps> = ({ page, showTitle = true }) => {
  return (
    <div className={styles.wrapper}>
      {showTitle ? <h2>{page?.title}</h2> : null}
      <MoneyBlocks blocks={page?.blocks} campaigns={page?.campaigns} />
    </div>
  );
};

export { getMoneyPage, getVertical } from './getMoneyPage';
